"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { BoxedButtonBase } from "./ButtonBase.js";
import { getButtonVariantProps } from "./createButtonVariant.js";
const DangerButton = forwardRef(function DangerButton2(props, ref) {
  return jsx(BoxedButtonBase, { ref, ...getButtonVariantProps("error", props) });
});
export {
  DangerButton
};
